import { render, staticRenderFns } from "./EditPositionDialog.vue?vue&type=template&id=89973ae2&"
import script from "./EditPositionDialog.vue?vue&type=script&lang=js&"
export * from "./EditPositionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports